/*
 * Copyright (c) 2024-2025 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as Sentry from '@sentry/astro'
import { Env } from '~/constants/env-vars'

let environment: string | undefined
try {
  const url = new URL(Env.CUSTOMER_PORTAL_BASE_URL)
  environment = url.hostname
} catch (error) {
  // no-op
}

Sentry.init({
  dsn: Env.SENTRY_DSN,
  tracePropagationTargets: [Env.CUSTOMER_PORTAL_BASE_URL ?? 'localhost', /^\//],
  integrations: [
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true
    }),
    Sentry.browserTracingIntegration()
  ],
  beforeSend(event, hint) {
    const status = (hint?.originalException as any)?.response?.status
    if (status && status >= 400 && status < 500) {
      return null
    }
    if (event.user) {
      delete event.user
    }
    return event
  },
  environment,
  tracesSampleRate: 0.0,
  profilesSampleRate: 0.0,
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 0.0
})
